import SectionWrapper from '../components/SectionWrapper';
import ScrollReveal from '../components/ScrollReveal';
import ChartRadarEval from '../charts/ChartRadarEval';
import ChartLineGrowth from '../charts/ChartLineGrowth';
import { COMPARISON_TABLE } from '../data/mockData';

// 区块4：核心可视化演示
export default function Section04Demo() {
  return (
    <SectionWrapper
      id="demo"
      title="核心可视化演示"
      subtitle="交互式五维雷达与四年成长曲线，直观呈现AI评价如何量化师范生教学能力成长轨迹。"
    >
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        {/* 左侧：交互式雷达图 */}
        <ScrollReveal>
          <div className="glass-card min-h-[520px]">
            <ChartRadarEval />
          </div>
        </ScrollReveal>

        {/* 右侧：成长曲线 */}
        <ScrollReveal delay={150}>
          <div className="glass-card min-h-[520px]">
            <ChartLineGrowth />
          </div>
        </ScrollReveal>
      </div>

      {/* 底部：三维对比表 */}
      <ScrollReveal delay={200}>
        <div className="glass-card mt-8 overflow-x-auto">
          <h3 className="text-2xl font-bold text-gold mb-6 text-center">
            传统微格 vs 现有AI系统 vs 数师有方
          </h3>
          <table className="comparison-table">
            <thead>
              <tr>
                {COMPARISON_TABLE.headers.map((header, index) => (
                  <th key={index}>{header}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {COMPARISON_TABLE.rows.map((row, rowIndex) => (
                <tr key={rowIndex}>
                  {row.map((cell, cellIndex) => (
                    <td
                      key={cellIndex}
                      className={
                        cellIndex === 3
                          ? 'text-gold font-bold'
                          : cellIndex === 0
                          ? 'text-white'
                          : 'text-slate-200'
                      }
                    >
                      {cell}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </ScrollReveal>
    </SectionWrapper>
  );
}
